import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { NavigationItemButton } from './NavigationItemButton';
import { NavigationHeader, NavigationItem } from './MainSidebar';
import { MenuButton } from './MenuButton';

type NavigationMainButtonProps = {
  navigationHeader: NavigationHeader;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
};
export const NavigationHeaderButton = ({ navigationHeader, setIsSidebarOpen }: NavigationMainButtonProps) => {
  const { pathname } = useLocation();
  const isActiveByUrl =
    navigationHeader.navigationSubItems?.some((item) => item && pathname.startsWith(item.navigate)) ?? false;
  const [isExpanded, setIsExpanded] = useState(isActiveByUrl);

  return (
    <Grid container direction="column" gap={0.25}>
      <MenuButton
        onClick={() => setIsExpanded((prev) => !prev)}
        name={navigationHeader.name}
        icon={navigationHeader.icon}
        hasChildren
        isExpanded={isExpanded}
        isOpenParent={isExpanded}
      />

      {isExpanded && (
        <Grid
          container
          direction="column"
          gap={0.25}
          sx={{
            width: 'auto',
            marginInlineStart: '22px',
            paddingInlineStart: '10px',
            borderInlineStart: '1px solid',
            borderColor: 'mb.control',
          }}>
          {navigationHeader.navigationSubItems?.map((navigationItem: NavigationItem | undefined) =>
            navigationItem ? (
              <NavigationItemButton
                key={navigationItem.key}
                setIsSidebarOpen={setIsSidebarOpen}
                navigationItem={navigationItem}
                isSubMenuItem
              />
            ) : null,
          )}
        </Grid>
      )}
    </Grid>
  );
};
